import videojs from 'video.js';
import vjsSrv from '../services/vjsSrv';
import eventsSrv from '../services/events';
import { PLAYER_EVENTS } from 'vimmi-web-utils/cjs/postMessage';
import { PMWrap } from '../services/PMWrap';
import Config from 'src/js/services/config';

export class SnapshotService {
  constructor() {
    this._canvas = null;
    this._context = null;
    this.options = {};
  }

  getCanvas(width, height) {
    this._canvas = document.createElement('canvas');
    this._canvas.width = width;
    this._canvas.height = height;
    this._context = this._canvas.getContext('2d');
  }

  enable(options) {
    this.options = Object.assign(this.options, options);
    let button = vjsSrv.vjsPlayer.controlBar.getChild('SnapshotButton');
    if (!button) {
      button = vjsSrv.vjsPlayer.controlBar.addChild('SnapshotButton');
    }
  }

  /** todo: */
  disable(options) {

  }

  getImage() {
    vjsSrv.vjsPlayer
      .pause();
    let width = this.options.width || vjsSrv.vjsPlayer.tech_.el_.clientWidth;
    let height = this.options.height || vjsSrv.vjsPlayer.tech_.el_.clientHeight;
    this.getCanvas(width, height);
    this._context.drawImage(vjsSrv.vjsPlayer.tech_.el_, 0, 0, width, height);
    this._canvas.toBlob((blob) => {
      //TODO: what is it?
      //      parent.postMessage('loadMyOrders', '*');

      eventsSrv.emit(PLAYER_EVENTS.SNAPSHOT_DATA, {
        blob: blob,
      });

      if (!Config.get('params.imported')) {
        PMWrap.inst().sendWrappedEvent(PLAYER_EVENTS.SNAPSHOT_DATA, {
          blob: blob,
        }, { sendMethod: 'blob' });
      }
    }, 'image/jpeg', 1);
    if (vjsSrv.vjsPlayer
      .isFullscreen()) {
      vjsSrv.vjsPlayer
        .exitFullscreen();
    }
  }
}

let Button = videojs.getComponent('Button');
let SnapshotButton = videojs.extend(Button, {
  constructor: function() {
    Button.apply(this, arguments);
    //      this.hide();
    //      this.disable();
    this.addClass('vjs-snapshot-btn');
    this.addClass('vjs-icon-spinner');
    this.controlText('Get snapshot');
  },
  handleClick: function() {
    vjsSrv.vjsPlayer.SnapshotSrv.getImage();
  },
});
videojs.registerComponent('SnapshotButton', SnapshotButton);